import { render } from "./LoginForm.vue?vue&type=template&id=bd5d62c2&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=bd5d62c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd5d62c2"

export default script